<!-- <div class="landing-cards animate__animated animate__fadeIn animate__delay-1s 1s"> -->
<div class="landing-cards__box" *ngFor="let card of cardInfo; let i = index">
    <span class="card-type" [innerHTML]="card.type"></span>

    <div class="icon-title">
        <div class="icon">
            <img [src]="card.icon" [alt]="card.title" />
        </div>
        <div class="title">
            <p [innerHTML]="card.title"></p>
            <span class="card-type-mobile" [innerHTML]="card.type"></span>
        </div>
    </div>
    <div class="description">
        <p [innerHTML]="card.description"></p>
    </div>
    <div class="button">
        <button class="btn-primary-bg" type="button" [innerHTML]="card.button_text" (click)="onRedirectTo(card.button_url, card.type)" *ngIf="i !== 2"></button>

        <button class="btn-primary-bg" type="button" [innerHTML]="card.button_text" (click)="onOpenNewTabBrowser(card.button_url, card.type)" *ngIf="i === 2"></button>
    </div>
</div>
<!-- </div> -->